import React from 'react';
import OrganizerDashboardInteractive from './components/OrganizerDashboardInteractive';

const OrganizerDashboardPage = () => {
  const dashboardData = {
    metrics: {
      activeEvents: 8,
      totalParticipants: 156,
      upcomingDeadlines: 3,
      engagementRate: 87.5,
      pendingApplications: 12,
      newInquiries: 5,
    },
    recentEvents: [
      {
        id: 1,
        title: '강남 테니스 오픈 매치',
        sportType: '테니스',
        date: '2026.01.15',
        time: '19:00',
        participants: 6,
        maxParticipants: 8,
        status: 'active',
        location: '강남 테니스장',
      },
      {
        id: 2,
        title: '주말 축구 친선전',
        sportType: '축구',
        date: '2026.01.18',
        time: '14:00',
        participants: 18,
        maxParticipants: 22,
        status: 'active',
        location: '월드컵 공원 축구장',
      },
      {
        id: 3,
        title: '농구 3on3 토너먼트',
        sportType: '농구',
        date: '2026.01.20',
        time: '10:00',
        participants: 12,
        maxParticipants: 12,
        status: 'full',
        location: '잠실 실내 체육관',
      },
    ],
    pendingApplications: [
      {
        id: 1,
        applicantName: '박지훈',
        applicantAvatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_14143eebd-1763298616876.png',
        applicantAvatarAlt: 'Profile photo of young Korean man with short black hair',
        eventTitle: '강남 테니스 오픈 매치',
        skillLevel: '중급',
        appliedDate: '2026.01.10',
        message: '테니스 경력 3년입니다. 즐겁게 참여하고 싶습니다!',
      },
      {
        id: 2,
        applicantName: '최수진',
        applicantAvatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_17eb4a1d7-1763298324036.png',
        applicantAvatarAlt: 'Profile photo of young Korean woman with long black hair',
        eventTitle: '주말 축구 친선전',
        skillLevel: '초급',
        appliedDate: '2026.01.11',
        message: '축구 처음이지만 열심히 하겠습니다!',
      },
    ],
    recentActivities: [
      {
        id: 1,
        type: 'application',
        message: '박지훈님이 강남 테니스 오픈 매치에 신청했습니다',
        timestamp: '10분 전',
        icon: 'UserPlusIcon',
      },
      {
        id: 2,
        type: 'inquiry',
        message: '이민수님이 주말 축구 친선전에 문의했습니다',
        timestamp: '1시간 전',
        icon: 'ChatBubbleLeftIcon',
      },
      {
        id: 3,
        type: 'completion',
        message: '농구 3on3 토너먼트 모집이 완료되었습니다',
        timestamp: '2시간 전',
        icon: 'CheckCircleIcon',
      },
      {
        id: 4,
        type: 'review',
        message: '강남 배드민턴 클럽 이벤트에 새로운 리뷰가 등록되었습니다',
        timestamp: '3시간 전',
        icon: 'StarIcon',
      },
    ],
    analytics: {
      participationTrend: [
        { month: '9월', participants: 120 },
        { month: '10월', participants: 145 },
        { month: '11월', participants: 138 },
        { month: '12월', participants: 156 },
      ],
      popularSports: [
        { sport: '축구', count: 45, percentage: 28.8 },
        { sport: '농구', count: 38, percentage: 24.4 },
        { sport: '테니스', count: 32, percentage: 20.5 },
        { sport: '배드민턴', count: 25, percentage: 16.0 },
        { sport: '기타', count: 16, percentage: 10.3 },
      ],
    },
  };

  return <OrganizerDashboardInteractive data={dashboardData} />;
};

export default OrganizerDashboardPage;
